import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { Row } from 'antd';
import { useMainUrl } from 'hooks/useMainUrl';
import {
  PageContainer,
  Title,
  CarouselResponsive,
  CardTestimonial,
  RowCustom,
  IconBg,
} from 'components';
import { Helmet } from 'react-helmet';

import { SearchBarPanel } from './parts/Header/SearchBarPanel';
import { MobileDeviceBreakpoint } from './parts/Header/SearchBarPanel.styles';
import { SearchBarPanelMobile } from './parts/Header/SearchBarPanelMobile';
import { useQuery } from '@apollo/react-hooks';
import {
  RECOMENDED_HOTELS,
  POPULAR_HOTELS,
  VIEWD_HOTELS,
  HISTORY_HOTELS,
  LandingInfoRegion_HOTELS,
} from 'graphql/queries/getHotels';

import { GET_REVIEWS } from 'graphql/queries/reviews';

import gql from 'graphql-tag';
import { WhyUsInfo } from './parts/WhyUsInfo';
import { TitleMain, CarouselWrapper } from './Main.styles';
import { Header } from './parts/Header/Header';
import { PopularDirectionsScroll } from './parts/PopularDirectionsScroll';
import { PopularDirections } from './parts/PopularDirections';
import ViewedVillas from './parts/ViewedVillas';
import RecommendedVillas from './parts/RecommendedVillas';
import RecommendedVillasScroll from './parts/RecommendedVillaScroll';
import { CollectionMasonryGrid } from './parts/CollectionMasonryGrid';
import MobileSearch from './parts/mobileSearch/MobileSearch';
import SearchHistory from './parts/SearchHistory';

const pluralize = require('numeralize-ru').pluralize;

const Main = () => {
  const intl = useIntl();
  const history = useHistory();
  const [mainUrl] = useMainUrl();
  const [isMobileSearchBarActive, setMobileSearchBarFocus] = useState(false);
  const [favoriteVillas, setFavoriteVillas] = useState([]);

  const {
    loading: loadingPopular,
    error: errorPopular,
    data: dataPopular,
  } = useQuery(POPULAR_HOTELS, {
    variables: {
      resultsNumber: 10,
      regionUrl: `${
        localStorage.language ? `${localStorage.language}/` : 'en/'
      }`,
    },
    fetchPolicy: 'network-only',
  });

  const {
    loading: loadingReviews,
    error: errorReviews,
    data: dataReviews,
  } = useQuery(GET_REVIEWS, {
    variables: {
      regionUrl: `${
        localStorage.language ? `${localStorage.language}/` : 'en/'
      }`,
      offset: 0,
      limit: 20,
    },
    fetchPolicy: 'network-only',
  });

  React.useEffect(() => {
    console.log('ACTION dataReviews', dataReviews);
  }, [dataReviews]);

  const {
    loading: loadingRecomended,
    error: errorRecomended,
    data: dataRecomended,
    refetch,
  } = useQuery(RECOMENDED_HOTELS, {
    variables: {
      resultsNumber: 9,
      regionUrl: `${
        localStorage.language ? `${localStorage.language}/` : 'en/'
      }`,
    },
    fetchPolicy: 'network-only',
  });

  const {
    loading: loadingViewed,
    error: errorViewed,
    data: dataViewed,
    refetch: refetchViewedVillas,
  } = useQuery(VIEWD_HOTELS, {
    variables: {
      lang: `${localStorage.language ? localStorage.language : 'en/'}`,
      limit: 3,
      offset: 0,
    },
    fetchPolicy: 'network-only',
  });

  React.useEffect(() => {
    let favorites = [];
    if (dataRecomended && dataRecomended.featuredProps) {
      dataRecomended.featuredProps.forEach((villa) => {
        if (villa.isInWishlist) {
          favorites.push(villa.id);
        }
      });
    }
    setFavoriteVillas(favorites);
  }, [dataRecomended]);

  React.useEffect(() => {
    let favorites = [];
    if (dataViewed) {
      if (dataViewed.viewedProps === null) {
        return;
      }
      dataViewed.viewedProps.propsList.forEach((villa) => {
        if (villa.isInWishlist) {
          favorites.push(villa.id);
        }
      });
    }
    setFavoriteVillas(favorites);
  }, [dataViewed]);

  console.log('DV:', dataViewed);

  const {
    loading: loadingLanding,
    error: errorLanding,
    data: dataLanding,
  } = useQuery(LandingInfoRegion_HOTELS, {
    variables: {
      regionUrl: `${
        localStorage.language ? `${localStorage.language}/` : 'en/'
      }`,
    },
    fetchPolicy: 'network-only',
  });

  React.useEffect(() => {
    console.log('dataLanding: ', history.location.pathname.slice(1));
    console.log('dataLanding: ', dataLanding);
    //dataLanding.landingInfo.collectionList
  }, [dataLanding]);

  const {
    loading: loadingHistory,
    error: errorHistory,
    data: dataHistory,
  } = useQuery(HISTORY_HOTELS, {
    variables: {
      lang: `${localStorage.language ? `${localStorage.language}/` : 'en/'}`,
      resultsNumber: 15,
    },
    fetchPolicy: 'network-only',
  });

  useEffect(() => {
    dataViewed && console.log('viewed data:', dataViewed);
    errorViewed && console.log('viewed data: errorViewed', errorViewed);
    dataPopular && console.log('dataPopular', dataPopular);

    dataHistory && console.log('ACTION data history:', dataHistory);
    errorHistory && console.log('ACTION history:', errorHistory);
  }, [dataViewed, dataHistory, dataPopular]);

  const onSearchFocus = (isActive) => {
    console.log('###: Mobile search bar active');
    setMobileSearchBarFocus(isActive);
  };

  if (isMobileSearchBarActive) {
    return (
      <div
        style={{
          height: '100%',
          width: '100%',
          overflow: 'hidden',
          zIndex: '1000',
          backgroundColor: '#ffffff',
          color: '#000',
          position: 'absolute',
          padding: '19px',
        }}
      >
        <MobileSearch setSearchVisibility={onSearchFocus} />
      </div>
    );
  }

  console.log('slice', history.location.pathname.slice(1));
  return (
    <>
      {dataLanding && dataLanding.landingInfo && (
        <Helmet>
          <title>{dataLanding.landingInfo.seoMeta.seoTitle}</title>
          <meta
            name="description"
            content={dataLanding.landingInfo.seoMeta.seoDescription}
          />
          <meta
            name="keywords"
            content={dataLanding.landingInfo.seoMeta.seoKeywords}
          />
          <link rel="canonical" href={`https://aktis.villas${mainUrl}`} />
        </Helmet>
      )}
      <Header>
        <MobileDeviceBreakpoint mobileMHidden>
          <SearchBarPanel margin="90px 0 140px 0" />
        </MobileDeviceBreakpoint>
        <MobileDeviceBreakpoint tabletHidden>
          <SearchBarPanelMobile onSearchFocus={onSearchFocus} />
        </MobileDeviceBreakpoint>
      </Header>
      <PageContainer
        width="90%"
        width1100="100%"
        maxWidth="1736px"
        maxWidthLaptop="100%"
        maxWidthSm="100%"
        marginSm="auto"
        margin="auto"
        padding="0"
        paddingMD="0 0 0 5vw"
        minHeight="100%"
      >
        <PageContainer
          padding="0"
          minHeight="100%"
          paddingMD="59px 0 0 0"
          padding1100="32px 0 0 5vw"
          maxWidth="100%"
          marginSm="auto"
          margin="0 0 7%"
        >
          {dataHistory && dataHistory.searchHistory.length > 0 && (
            <SearchHistory dataHistory={dataHistory} />
          )}
          {dataViewed &&
            dataViewed.viewedProps &&
            dataViewed.viewedProps.propsList.length > 0 && (
              <ViewedVillas
                setFavoriteVillas={setFavoriteVillas}
                favoriteVillas={favoriteVillas}
                loading={loadingViewed}
                dataViewed={dataViewed}
                refetchVillas={() => refetchViewedVillas()}
              />
            )}

          {/* {dataRecomended && dataRecomended.featuredProps.length > 0 && (
          <RecommendedVillasScroll dataRecomended={dataViewed} />
        )} */}
          {dataRecomended && dataRecomended.featuredProps.length > 0 && (
            <RecommendedVillasScroll
              refetchVillas={refetch}
              setFavoriteVillas={setFavoriteVillas}
              favoriteVillas={favoriteVillas}
              dataRecomended={dataRecomended}
            />
          )}
        </PageContainer>
      </PageContainer>
      <WhyUsInfo />
      <PageContainer
        maxWidthSm="100%"
        marginSm="auto"
        margin="auto"
        padding="0 0 0 5vw"
        minHeight="auto"
      >
        <PageContainer
          paddingMD="19px 0 25px 0"
          padding="50px 0"
          minHeight="100%"
        >
          <Title sizeMbl="12px" size="18px" mutedText center>
            {intl.formatMessage({
              id: 'main-page.our-clients',
              defaultMessage: 'Guest experience',
            })}
          </Title>
          <TitleMain
            size="36px"
            weight="500"
            sizeM="18px"
            margin="0 0 5px 0"
            center
          >
            {intl.formatMessage({
              id: 'main-page.reviews',
              defaultMessage: 'Feedback',
            })}
          </TitleMain>
          {dataReviews && dataReviews.landingReviews.reviewsList.length > 0 && (
            <CarouselWrapper>
              <CarouselResponsive
                responsive={[
                  {
                    breakpoint: 4000,
                    settings: {
                      slidesToShow: 3,
                      slidesToScroll: 3,
                      infinite: true,
                      dots: true,
                    },
                  },
                  {
                    breakpoint: 1300,
                    settings: {
                      slidesToShow: 2.5,
                      slidesToScroll: 2.5,
                      dots: true,
                      centerPadding: '20px',
                      infinite: false,
                    },
                  },
                  {
                    breakpoint: 1000,
                    settings: {
                      slidesToShow: 2,
                      slidesToScroll: 2,
                      dots: true,
                      centerPadding: '20px',
                      infinite: false,
                    },
                  },
                  {
                    breakpoint: 750,
                    settings: {
                      slidesToShow: 1.5,
                      slidesToScroll: 1.5,
                      initialSlide: 1,
                      dots: true,
                      centerMode: true,
                      centerPadding: '20px',
                      infinite: false,
                    },
                  },
                  {
                    breakpoint: 480,
                    settings: {
                      slidesToShow: 1,
                      slidesToScroll: 1,
                      dots: true,
                      centerMode: true,
                      centerPadding: '20px',
                      infinite: false,
                    },
                  },
                ]}
              >
                {dataReviews.landingReviews.reviewsList.map((review) => (
                  <CardTestimonial reviewItem={review} />
                ))}
              </CarouselResponsive>
            </CarouselWrapper>
          )}
        </PageContainer>
      </PageContainer>
      <PageContainer
        padding="0 0 0 4.7vw"
        minHeight="100%"
        paddingMD="61px 0 0 0"
        padding1100="32px 0"
        maxWidthSm="100%"
        marginSm="auto"
        margin="auto"
      >
        {dataPopular && dataPopular.featuredRegions.length && (
          <Title
            size="18px"
            sizeLaptopL="12px"
            size1100="18px"
            mutedText
            margin="0"
            paddingFrom1890="0"
            padding1890="0"
            padding1100="0 0 0 5.7vw"
          >
            {intl.formatMessage({
              id: 'main-page.popular-directions',
              defaultMessage: 'Mostly searched destinations',
            })}
          </Title>
        )}

        <TitleMain
          size="36px"
          size1100="24px"
          sizeM="18px"
          weight="500"
          margin="0 0 17px 0"
          paddingFrom1890="0"
          padding1890="0"
          padding1100="0 0 0 5.7vw"
        >
          {intl.formatMessage({
            id: 'main-page.popular',
            defaultMessage: 'Popular Destinations',
          })}
        </TitleMain>
        {/* <MobileDeviceBreakpoint mobileMHidden>
          <PopularDirections dataPopular={dataPopular} />
        </MobileDeviceBreakpoint> */}
        {/* <MobileDeviceBreakpoint tabletHidden> */}
        <PopularDirectionsScroll dataPopular={dataPopular} />
        {/* </MobileDeviceBreakpoint> */}
      </PageContainer>
      <PageContainer
        minHeight="100%"
        maxWidth="90%"
        maxWidthLaptop="100%"
        maxWidthSm="100%"
        marginSm="auto"
        margin="auto"
        padding="0"
      >
        <PageContainer
          padding="100px 0 0 0"
          minHeight="100%"
          paddingMD="61px 0 0 0"
          padding1100="32px 0"
          maxWidth="1750px"
          maxWidthSm="100%"
          marginSm="auto"
          margin="auto"
        >
          {dataLanding && dataLanding.landingInfo.collectionList && (
            <>
              {' '}
              <Title
                padding="0"
                padding1100="0 5.7vw"
                paddingFrom1890="0 0 30px 0"
                sizeMbl="12px"
                size="18px"
                mutedText
              >
                {intl.formatMessage({
                  id: 'main-page.offers',
                  defaultMessage: 'Need some inspiration?',
                })}
              </Title>
              <TitleMain
                size="36px"
                size1100="24px"
                sizeM="18px"
                weight="500"
                margin="0 0 17px 0"
                padding="0 0 30px"
                padding1100="0 5.7vw"
                paddingFrom1890="0 0 30px 0"
              >
                {intl.formatMessage({
                  id: 'main-page.collections',
                  defaultMessage: 'Collections',
                })}
              </TitleMain>
            </>
          )}
          <Row justify="center">
            <PageContainer
              minHeight="100%"
              width="100%"
              padding="0 0 30px"
              paddingFrom1890="0 0 30px 0"
              paddingMD="0 5vw 30px"
              padding1100="0 5.7vw"
            >
              <CollectionMasonryGrid dataLanding={dataLanding} />
            </PageContainer>
          </Row>
        </PageContainer>
      </PageContainer>
    </>
  );
};
export default Main;
